///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-category.ts"/>


module Meevo.Components.Controls.SmartMover {


    import IReportService = Meevo.Plugins.Reports.IReportService;
    import IReportServiceCategory = Meevo.Plugins.Reports.IReportServiceCategory;
    import ServiceCategory = Model.ServiceCategory;
    import Service = Model.Service;

    export class ServiceToCategoryStrategy implements ICollectionPopulate {
        constructor(public parent: ICollectionBase<IReportServiceCategory>, public child: ICollectionBase<IReportService>) {
        }

        populate(): void {
            for (const category of this.parent.models) {
                (<ISmartMoverCategoryModel<IReportServiceCategory>>category).resetModels(
                    this.child.models.filter((service) => service.get('categoryDisplayId') === category.get('id'))
                );
            }
        }
    }

    export class CoreServiceToCategoryStrategy implements ICollectionPopulate {
        constructor(public parent: ICollectionBase<ServiceCategory>, public child: ICollectionBase<Service>) {
        }

        populate(): void {
            for (const category of this.parent.models) {
                (<ISmartMoverCategoryModel<ServiceCategory>>category).resetModels(
                    this.child.models.filter((service) => service.get('serviceCategoryId') === category.get('id'))
                );
            }
        }
    }
}
